export function splitMacros(macros = []) {
    const active = []
    const deleted = []
    macros.forEach((macro) => {
        if (macro?._deleted) {
            deleted.push(macro)
        } else {
            active.push(macro)
        }
    })
    return { activeMacros: active, deletedMacros: deleted }
}
